import type { ShareChannel } from 'src/app/shared/hooks/share';

export type Channel = Exclude<
	ShareChannel,
	'facebookMessenger' | 'tiktok' | 'vk' | 'line' | 'nextdoor' | 'reddit' | 'qrcode' | 'flyer'
>;

export const CHANNELS: readonly Channel[] = [
	'facebook',
	'twitter',
	'email',
	'whatsapp',
	'instagramStories',
	'copy',
	'sms',
	'instagram',
	'mobileNativeShare',
];
